module.exports = __webpack_public_path__ + "static/media/yess.io-dashboard.329204dd.webp";